import React, { useState, useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './App';
import { useWallet } from './WalletContext';

export const PremiumRoute = ({ children, pageName }) => {
  const { user } = useAuth();
  const { balance, isPremium } = useWallet();
  const location = useLocation();

  if (!user) {
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  if (isPremium) {
    return children;
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8 bg-white p-8 rounded-lg shadow-lg text-center border-t-4 border-orange-500">
        <div>
          <h2 className="mt-6 text-3xl font-extrabold text-orange-600">Premium Content</h2>
          <p className="mt-2 text-sm text-gray-600">
            This page ({pageName}) is exclusively for Premium Members.
          </p>
        </div>
        
        <div className="bg-orange-50 p-4 rounded-md border border-orange-200">
          <p className="text-orange-800 font-bold mb-2">Wallet Balance: Rs. {balance}</p>
          <p className="text-orange-700 text-sm">
            Premium minimum balance required: Rs. 100
          </p>
        </div>

        <div className="text-red-600 font-medium">
          You must recharge and maintain a minimum balance of Rs. 100 to become a Premium Member.
        </div>
        
        <p className="text-sm text-gray-500 mt-4 text-left">
          <strong>How it works:</strong> As a premium member, you are not charged just to view the page. You will only be charged Rs. 25 after successfully generating 5 PDFs, Prints, or Shares across any premium pages.
        </p>

        <a
          href="/profile"
          className="w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-green-600 hover:bg-green-700 mt-4"
        >
          Go to Wallet to Recharge
        </a>
      </div>
    </div>
  );
};
